import { render, staticRenderFns } from "./ApplicableShops.vue?vue&type=template&id=2b1d61f3&scoped=true"
import script from "./ApplicableShops.vue?vue&type=script&lang=ts"
export * from "./ApplicableShops.vue?vue&type=script&lang=ts"
import style0 from "./ApplicableShops.vue?vue&type=style&index=0&id=2b1d61f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1d61f3",
  null
  
)

export default component.exports